var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7444_13592)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.3843 12.867L9.0222 16.2152L16.3843 20.5648L23.7436 16.2152L16.3843 12.867Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.0222 16.2152L16.3843 20.5648V4L9.0222 16.2152Z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3843 4V20.5648L23.7436 16.2152L16.3843 4Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.0222 17.6101L16.3843 27.9819V21.9596L9.0222 17.6101Z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3843 21.9596V27.9819L23.7493 17.6101L16.3843 21.9596Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7444_13592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7658,
    height: 24,
    transform: "translate(9 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.03c58e04b2d05899116775550fa23452.svg";
export { ForwardRef as ReactComponent };